export const REDIS_KEY_TWILIO_PHONE_ROOMMATE_INVITE = 'REDIS_KEY_TWILIO_PHONE_ROOMMATE_INVITE';
export const REDIS_AUTO_ASSIGN_HOUSEHOLD_ADMIN_USER_ROUND_ROBIN_INDEX_KEY = 'auto-assign-household-admin-user-round-robin-index'; // eslint-disable-line max-len
export const REDIS_KEY_QUICKBOOKS_API_REFRESH_TOKEN = 'quickbooks-api-refresh-token';
export const REDIS_KEY_QUICKBOOKS_API_ACCESS_TOKEN = 'quickbooks-api-access-token';
export const REDIS_KEY_RENTLINX_VERIFICATION_COOKIE = 'rentlinx-verification-cookie';
export const REDIS_KEY_REDIRECTIONS_URL_CODE_INDEX = 'redirections-url-code-index';

export function createRedisNamespace(...args) {
  return args.join(':');
}

export function createRedisKeyFrontMessageWaitingForDelivery(phone) {
  return createRedisNamespace(
    'front-message-waiting-for-delivery',
    phone,
  );
}

export function createRedisKeyFrontChannelsUsedToSendMessage(phone) {
  return createRedisNamespace(
    'front-channels-used-to-send-message',
    phone,
  );
}

export function createRedisKeyFrontChannelsRoundRobin(marketId) {
  return createRedisNamespace(
    'front-channel-round-robin-index',
    marketId,
  );
}

export function createRedisKeyApartmentLocatorRoundRobin(marketId) {
  return createRedisNamespace(
    'apartment-locator-round-robin-index',
    marketId,
  );
}

export function createRedisKeyAccountManagerRoundRobin() {
  return createRedisNamespace(
    'account-manager-round-robin-index',
  );
}

export function createRedisKeySalesRepRoundRobin() {
  return createRedisNamespace(
    'sales-rep-round-robin-index',
  );
}

export function createRedisKeySuggestedSearchFilterResultsCount(suggestedSearchFilterId) {
  return createRedisNamespace(
    'renter-suggested-search-filter-results-count',
    suggestedSearchFilterId,
  );
}

export function createRedisKeyTourDatesUnavailable(marketId) {
  return createRedisNamespace(
    'tour-dates-unavailable',
    marketId,
  );
}

export function createRedisKeyUserLastLocation(userId) {
  return createRedisNamespace(
    'user-last-location',
    userId,
  );
}

export function createRedisKeyUserLastRequestedSelfTour(userId) {
  return createRedisNamespace(
    'user-last-self-tour',
    userId,
  );
}
